import type { SVGProps } from 'react'

/**
 * Solid counterparts to lucide's `ThumbsUp`/`ThumbsDown`, for the rated state.
 *
 * Filling the lucide icons directly doesn't read as solid: their wrist divider
 * (`M7 10v12`) is a separate stroke with round caps, so it pokes a nub past the
 * silhouette at both ends and leaves a seam across the fill. These drop that
 * line and keep only lucide's body path, filled *and* stroked at the same
 * width — so the rated glyph sits inside exactly the outline version's
 * silhouette and swapping between them doesn't shift a pixel.
 */

const solidProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'currentColor',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const

export function ThumbsUpSolid(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...solidProps} {...props}>
      <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
    </svg>
  )
}

export function ThumbsDownSolid(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...solidProps} {...props}>
      <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" />
    </svg>
  )
}
